import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceCreateProjectStatusNotificationState = createStateReducer(
  initialState,
  {
    [events.createProjectStatusSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "createProjectStatus",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.createProjectStatusFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "createProjectStatus",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceCreateProjectStatusNotificationState };
